
import { css } from 'lit';
export default css`
pc-heading{
  display:block;
}

  pc-heading h1,
  pc-heading h2,
  pc-heading h3,
  pc-heading h4,
  pc-heading h5,
  pc-heading h6,
  pc-heading p{
    all:unset;
  }

  pc-heading .heading-h1{
    font-weight:var(--fw-light);
    font-weight:var(--heading-font-weight, var(--fw-light));
    font-size:var(--fs-h1-mobile);
    line-height:var(--lh-h1);
    line-height:var(--heading-line-height, var(--lh-h1));
    font-family:var(--ff-display);
    font-family:var(--heading-font-family, var(--ff-display));
  }

  pc-heading .heading-h2{
    font-weight:var(--fw-light);
    font-weight:var(--heading-font-weight, var(--fw-light));
    font-size:var(--fs-h2-mobile);
    font-size:var(--heading-font-size-mobile, var(--fs-h2-mobile));
    line-height:var(--lh-h2);
    line-height:var(--heading-line-height, var(--lh-h2));
    font-family:var(--ff-display);
    font-family:var(--heading-font-family, var(--ff-display));
  }

  pc-heading .heading-h3{
    font-weight:var(--fw-normal);
    font-weight:var(--heading-font-weight, var(--fw-normal));
    font-size:var(--fs-h3-mobile);
    font-size:var(--heading-font-size-mobile, var(--fs-h3-mobile));
    line-height:var(--lh-h3);
    line-height:var(--heading-line-height, var(--lh-h3));
    font-family:var(--ff-body);
  }

  pc-heading .heading-h4{
    font-weight:var(--fw-light);
    font-weight:var(--heading-font-weight, var(--fw-light));
    font-size:var(--fs-h4-mobile);
    font-size:var(--heading-font-size-mobile, var(--fs-h4-mobile));
    line-height:var(--lh-h4);
    line-height:var(--heading-line-height, var(--lh-h4));
    font-family:var(--ff-display);
    font-family:var(--heading-font-family, var(--ff-display));
  }

  @media print{

  pc-heading .heading-h4{
      --heading-font-size-mobile:var(--fs-2xl-print)
  }
    }

  pc-heading .heading-h5{
    font-weight:var(--fw-normal);
    font-weight:var(--heading-font-weight, var(--fw-normal));
    font-size:var(--fs-h5-mobile);
    font-size:var(--heading-font-size-mobile, var(--fs-h5-mobile));
    line-height:var(--lh-h5);
    line-height:var(--heading-line-height, var(--lh-h5));
    font-family:var(--ff-body);
  }

  @media print{

  pc-heading .heading-h5{
      --heading-font-size-mobile:var(--fs-2xl);
      --heading-font-weight:var(--fw-light)
  }
    }

  pc-heading .heading-h6{
    font-weight:var(--fw-normal);
    font-weight:var(--heading-font-weight, var(--fw-normal));
    font-size:var(--fs-h6-mobile);
    font-size:var(--heading-font-size-mobile, var(--fs-h6-mobile));
    line-height:var(--lh-h6);
    line-height:var(--heading-line-height, var(--lh-h6));
    font-family:var(--ff-display);
    font-family:var(--heading-font-family, var(--ff-display));
  }

  pc-heading .heading-eyebrow{
    font-weight:var(--fw-medium);
    font-size:var(--fs-eyebrow-mobile);
    font-size:var(--fs-heading-font-size, var(--fs-eyebrow-mobile));
    line-height:var(--lh-eyebrow-mobile);
    line-height:var(--heading-line-height, var(--lh-eyebrow-mobile));
    font-family:var(--ff-body);
    letter-spacing:var(--ls-eyebrow);
    text-transform:uppercase;
    color:var(--neutral-charcoal);
  }

  pc-heading .heading-eyebrow-secondary{
    font-family:var(--ff-body);
    font-size:var(--fs-body);
    font-size:var(--heading-font-size-mobile, var(--fs-body));
    font-weight:var(--fw-medium);
    line-height:var(--lh-body);
    line-height:var(--heading-line-height, var(--lh-body));
    color:var(--neutral-charcoal);
  }

  pc-heading .heading-bold{
    font-weight:var(--fw-bold);
  }

  pc-heading .heading-medium{
    font-weight:var(--fw-medium);
  }

  pc-heading .heading-light{
    font-weight:var(--fw-light);
  }

  pc-heading .heading-body{
    font-family:var(--ff-body);
  }

  pc-heading .heading-display{
    font-family:var(--ff-display);
  }

  pc-heading .heading-gray{
    color:var(--neutral-medium-gray);
  }

  pc-heading .heading-charcoal{
    color:var(--neutral-charcoal);
  }

  pc-heading .heading-eggplant{
    color:var(--primary-eggplant);
  }

  @media print{

  pc-heading h3.print-heading-insight{
      color:var(--primary-eggplant);
      font-weight:300
  }
    }

@media (min-width: 768px){
    pc-heading .heading-h1{
      font-size:var(--fs-h1);
      font-size:var(--heading-font-size, var(--fs-h1));
    }

    pc-heading .heading-h2{
      font-size:var(--fs-h2);
      font-size:var(--heading-font-size, var(--fs-h2));
    }

    pc-heading .heading-h3{
      font-size:var(--fs-h3);
      font-size:var(--heading-font-size, var(--fs-h3));
    }

    pc-heading .heading-h4{
      font-size:var(--fs-h4);
      font-size:var(--heading-font-size, var(--fs-h4));
    }

    pc-heading .heading-h5{
      font-size:var(--fs-h5);
      font-size:var(--heading-font-size, var(--fs-h5));
    }

    pc-heading .heading-h6{
      font-size:var(--fs-h6);
      font-size:var(--heading-font-size, var(--fs-h6));
    }

    pc-heading .heading-eyebrow{
      font-size:var(--fs-eyebrow);
      font-size:var(--heading-font-size, var(--fs-eyebrow));
      line-height:var(--lh-eyebrow);
      line-height:var(--heading-line-height, var(--lh-eyebrow));
    }
}
`;